module.exports = __webpack_public_path__ + "static/media/incognito-avatar.e55e710d.jpg";